<script setup lang="ts">
import MenuItem from '@/components/FloatMenu/FloatMenuOption/indev.vue'
import { getHostname } from '~~/src/api'
import type { Elemental } from '~~/src/types/elemental'

const { elemental, route } = defineProps<{
  elemental: Elemental
  route: string
}>()

const { copied, copy } = useClipboard()
const host = getHostname()

const copyId = () => {
  const link = `${host}/${route}/${elemental.url}`
  copy(link)
}

defineOptions({
  name: 'CopyElementalLinkOption',
})
</script>

<template>
  <MenuItem @select="copyId">
    <template #icon>
      <div v-if="copied" i-mdi:check w-3 h-3 />
      <IconLink v-else w-3 h-3 />
    </template>
    Get Link
  </MenuItem>
</template>
